import React from "react";

import HeroSection from "components/hero-section";

const StatBlock = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="text-center space-y-1 p-4">
      <dt className="text-primary font-bold text-2xl md:text-3xl">{value}</dt>
      <dd className="text-gray-700 max-w-[200px] mx-auto">{label}</dd>
    </div>
  );
};

const Stats = () => (
  <div className="bg-gray-100">
    <HeroSection className="py-4 sm:py-4 lg:py-4">
      <HeroSection.Content className="text-sm flex flex-col justify-center gap-x-8 gap-y-4 px-4 lg:px-4 xl:items-center xl:flex-row">
        <dl className="grow grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4">
          <StatBlock label="Chat satisfaction score across 50k+ chats in 2025" value="97%" />
          <StatBlock label="Average response time from a real human or Flo" value="<1 min" />
          <StatBlock label="Flo AI satisfaction score (most recent month)" value="100%" />
          <StatBlock label="Support chats handled in 2025" value="50k+" />
        </dl>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default Stats;
